import { useMemo } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useQuery } from '@apollo/client';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { momentParse } from '../../utils/time';
import { eventHeaderSeriesUpcomingEventsQuery } from '../../apollo/events';
import Loading from '../loading';
import EventListing from '../event-listing';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
    backgroundColor: theme.palette.secondary.light,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      paddingBottom: theme.spacing(1.5),
      borderLeftWidth: 0,
      borderRightWidth: 0,
    },
  },
  header: {
    marginTop: 0,
    marginBottom: theme.spacing(2),
  },
}));

const EventSeriesUpcoming = ({ event }) => {
  const { startAt, endAt, series, timezone } = event;
  const classes = useStyles();

  const isPast = useMemo(() => {
    const end = momentParse(endAt || startAt, timezone);
    return momentParse().isAfter(momentParse(end));
  }, [startAt, endAt, timezone]);

  const { data, loading } = useQuery(eventHeaderSeriesUpcomingEventsQuery, {
    variables: {
      id: _get(series, 'id'),
    },
    skip: !series || !isPast,
  });
  const upcomingEvents = _get(data, 'eventSeries.upcomingEvents', []);

  if (loading) {
    return <Loading compact />
  }

  if (!upcomingEvents.length) {
    return null;
  }

  return (
    <Container
      maxWidth="md"
      component="div"
      className={classes.container}
    >
      <Typography variant="h3" className={classes.header}>
        The event below already happened, but check out the next event in this series:
      </Typography>
      <EventListing event={upcomingEvents[0]} fullDate />
    </Container>
  );
};

EventSeriesUpcoming.propTypes = {
  event: PropTypes.object
};

export default EventSeriesUpcoming;
